// @ts-nocheck
/**
 * BRINUTI — RAGADÓS GOMB KÉT ÁLLAPOTTAL (C2)
 *
 * A doksi 02/1-3 callout 4. pontja: a ragadós gomb ma végig „Személyre
 * szabás", ár nélkül, állapot nélkül. Az új viselkedés:
 *
 *   1. állapot — „Személyre szabom"    → a Teeinblue blokkra görget
 *      (a nyilat a tulaj kérésére vettük le, 2026-09-15)
 *   2. állapot — „Kosárba · {ár} Ft"   → a Teeinblue saját kosárgombját nyomja
 *
 * A gomb NEM a miénk: a Teeinblue app rajzolja ki, és a saját blokkját
 * bármikor újrarendereli (szín- vagy szövegválasztáskor). Ezért:
 *   - nem cseréljük le az elemet, csak a feliratát írjuk át,
 *   - a kattintást a dokumentumon fogjuk el (capture fázisban), így az app
 *     újrarenderelése után is működik,
 *   - MutationObserver figyeli az állapotot, kifutással (a sok apró
 *     DOM-változás egyetlen frissítéssé olvad össze).
 *
 * Ha bármi hiányzik (nincs gomb, nincs kosárgomb), csendben nem csinálunk
 * semmit — a Teeinblue eredeti viselkedése marad.
 */
(function () {
  'use strict';

  const RAGADOS = '.tee-btn--personalize';
  const KOSAR = '.tee-btn--atc';

  let keszAllapot = false;
  let idozito = null;

  function ragadosGomb() {
    return document.querySelector(RAGADOS);
  }

  function kosarGomb() {
    return document.querySelector(KOSAR);
  }

  /**
   * A Teeinblue szerkesztő — ide görgetünk az 1. állapotban.
   * 2026-09-15: a régi választó ('.tee-block, [id*="teeinblue"]') a rejtett
   * <script id="teeinblue-product-data"> elemet találta meg, arra pedig nem
   * lehet görgetni, ezért a gomb „nem vitt sehova” (a tulaj jelezte).
   */
  function konfiguratorBlokk() {
    return document.querySelector('#tee-artwork-form, .tee-form-wrapper');
  }

  /** A szerkesztő teteje a ragadós fejléc alatt, 12 px levegővel. */
  function konfiguratorPont(blokk) {
    const fejlec = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
    return Math.max(0, blokk.getBoundingClientRect().top + window.scrollY - fejlec - 12);
  }

  /**
   * Az aktuális ár szövege. A Teeinblue saját árelemét olvassuk, mert az
   * követi a választásokat (belív, szalag); ha nincs, a fold-ban kiírt
   * alapárra esünk vissza.
   * @returns {string}
   */
  function arSzoveg() {
    const teeAr = document.querySelector('.tee-product-price .money, .tee-product-price');
    if (teeAr) {
      const talalat = (teeAr.textContent || '').match(/[\d\s.,]+\s*Ft/);
      if (talalat) return talalat[0].replace(/\s+/g, ' ').trim();
    }

    const sajat = document.querySelector('.brinuti-fold__ar-fo');
    return sajat ? sajat.textContent.trim() : '';
  }

  /* A feltöltött fotó ténye. A Teeinblue a feltöltés után újrarendereli a
     saját blokkját, és a <input type="file"> `files` listája ilyenkor már
     üres — ezért jegyezzük meg magunknak, amikor megtörtént. */
  let feltoltottKep = false;

  document.addEventListener(
    'change',
    function (e) {
      const mezo = e.target;
      if (mezo && mezo.type === 'file' && mezo.files && mezo.files.length) {
        feltoltottKep = true;
      }
    },
    true
  );

  /**
   * Ki van-e töltve minden kötelező mező a konfigurátorban?
   *
   * A Teeinblue NEM használ `required` attribútumot, és a kosárgombját sem
   * tiltja le üres űrlapnál (lemérve: 0 db [required] a termékoldalon).
   * Ezért a tényleges mezőket nézzük:
   *   - a `layer-…` nevű szövegmezőket (név / cím / monogram),
   *   - és ha van fotófeltöltő, azt is, hogy tényleg feltöltöttek-e képet.
   *
   * A rádiógombokat (szín, szalag) nem vizsgáljuk: azoknak mindig van
   * alapértelmezett értékük.
   */
  function mezokKeszek() {
    const szovegek = document.querySelectorAll(
      'textarea[name^="layer-"], input[type="text"][name^="layer-"]'
    );

    let voltLathato = false;
    for (let i = 0; i < szovegek.length; i += 1) {
      const mezo = szovegek[i];
      if (mezo.offsetParent === null) continue;
      voltLathato = true;
      if (!String(mezo.value || '').trim()) return false;
    }

    const kepMezo = document.querySelector('input[type="file"]');
    const kellKep = !!kepMezo && kepMezo.offsetParent !== null;
    if (kellKep && !feltoltottKep) return false;

    return voltLathato || kellKep;
  }

  /**
   * EGY ÁR LEGYEN AZ OLDALON, NE KETTŐ.
   *
   * A képernyőterv szerint az ár a cím alatt, a három pont fölött áll — ezt a
   * téma írja ki (brinuti-pdp-fold.liquid). A Teeinblue viszont a saját
   * blokkjában is megmutatja ugyanazt, pár száz pixellel lejjebb: asztali
   * nézetben a vásárló kétszer látta a 11.900 Ft-ot.
   *
   * Nem eldobjuk a Teeinblue árát, hanem ÁTMÁSOLJUK a fold-ba, és csak utána
   * rejtjük el. Így az opciótól függő (belív, szalag) árváltozás is a fenti
   * soron látszik. Ha az ár közben eltér az alapártól, az áthúzott ár és a
   * kedvezmény-jelvény eltűnik, mert azok már nem ehhez az árhoz tartoznak.
   */
  function arSzinkron() {
    const teeDoboz = document.querySelector('.tee-product-price');
    const sajatAr = document.querySelector('.brinuti-fold__ar-fo');
    if (!teeDoboz || !sajatAr) return;

    const teeAr = teeDoboz.querySelector('.tee-price--current');
    const szoveg = teeAr ? (teeAr.textContent || '').replace(/\s+/g, ' ').trim() : '';

    if (szoveg) {
      if (!sajatAr.dataset.alapAr) sajatAr.dataset.alapAr = sajatAr.textContent.trim();

      if (sajatAr.textContent.trim() !== szoveg) sajatAr.textContent = szoveg;

      const valtozott = szoveg !== sajatAr.dataset.alapAr;
      ['.brinuti-fold__ar-regi', '.brinuti-fold__ar-jel'].forEach(function (valaszto) {
        const elem = document.querySelector(valaszto);
        if (elem) elem.hidden = valtozott;
      });
    }

    teeDoboz.classList.add('brinuti-tee-ar-rejtve');
  }

  function allapotFrissites() {
    arSzinkron();

    const gomb = ragadosGomb();
    if (!gomb) return;

    const kesz = mezokKeszek() && !!kosarGomb();

    if (kesz) {
      const ar = arSzoveg();
      const felirat = ar ? 'Kosárba · ' + ar : 'Kosárba';
      if (gomb.textContent.trim() !== felirat) gomb.textContent = felirat;
      gomb.setAttribute('data-brinuti-allapot', 'kosar');
    } else {
      if (gomb.textContent.trim() !== 'Személyre szabom') gomb.textContent = 'Személyre szabom';
      gomb.setAttribute('data-brinuti-allapot', 'szabas');
    }

    keszAllapot = kesz;
  }

  function halasztottFrissites() {
    if (idozito) clearTimeout(idozito);
    idozito = setTimeout(function () {
      allapotFrissites();
      egySavLatszik();
    }, 150);
  }

  /* A kattintást capture fázisban fogjuk el, hogy a Teeinblue saját
     kezelője előtt döntsünk. Az 1. állapotban nem engedjük tovább (mi
     görgetünk), a 2.-ban a kosárgombot nyomjuk meg helyette. */
  document.addEventListener(
    'click',
    function (e) {
      const gomb = e.target && e.target.closest ? e.target.closest(RAGADOS) : null;
      if (!gomb) return;

      if (keszAllapot) {
        const kosar = kosarGomb();
        if (kosar) {
          e.preventDefault();
          e.stopPropagation();
          if (window.brinutiEsemeny) window.brinutiEsemeny('sticky_add_to_cart');
          kosar.click();
        }
        return;
      }

      const blokk = konfiguratorBlokk();
      if (blokk) {
        e.preventDefault();
        e.stopPropagation();
        if (window.brinutiEsemeny) window.brinutiEsemeny('sticky_personalize_click');
        window.scrollTo({ top: konfiguratorPont(blokk), behavior: 'smooth' });
        /* Ha a sima görgetés elakadt vagy közben képek töltődtek be fölötte,
           a végén a helyére ugrunk. */
        setTimeout(function () {
          const pont = konfiguratorPont(blokk);
          if (Math.abs(pont - window.scrollY) > 4) window.scrollTo({ top: pont, behavior: 'instant' });
        }, 1200);
      }
    },
    true
  );

  /* A safe-area padding az iPhone gesztussáv miatt kell: a doksi C2
     elfogadási feltétele, hogy a gomb teljes magasságában érinthető legyen
     Facebook és Instagram beépített böngészőben is. */
  function safeArea() {
    const doboz = document.querySelector('.tee-btn-wrapper--personalize');
    if (doboz) doboz.classList.add('brinuti-ragados-safe');
  }

  /* TELEFONON MINDIG LÁTSZIK (a tulaj kérése, 2026-09-15: „eltűnt”).
     A Teeinblue inline display:none-nal rejti a sávot, amíg a saját
     kosárgombja a képernyőn van. A tömörített fold óta ez a gomb már az első
     képernyő alján áll, így a sáv csak kb. 1500 px görgetés után jelent meg.
     Az inline stílust egy !important szabály írja felül, 749 px alatt. */
  function mobilonLathato() {
    if (document.getElementById('brinuti-ragados-stilus')) return;
    const stilus = document.createElement('style');
    stilus.id = 'brinuti-ragados-stilus';
    stilus.textContent =
      '@media screen and (max-width: 749px) {' +
      '.tee-btn-wrapper--personalize { display: block !important; }' +
      '.tee-btn-wrapper--personalize[data-brinuti-rejt] { display: none !important; }' +
      /* Ha a mi sávunk látszik, a Teeinblue gombsora NE tapadjon le: két sáv
         soha nem csúszhat egymásra (2. elemző PDF, mobil 1. pont). */
      '#tee-artwork-form #teeFormActions[data-brinuti-alap] { position: static !important; }' +
      '}';
    document.head.appendChild(stilus);
  }

  /* KÉT RAGADÓS SÁV HELYETT MINDIG CSAK EGY (2. elemző PDF, mobil 1. pont).

     A Teeinblue gombsora (#teeFormActions: Előnézet + Kosárba rakom) az
     űrlapon belül `position: sticky; bottom: 0`. A mi „Személyre szabom"
     sávunk viszont `position: fixed`, z-index 998 — vagyis amíg a vásárló a
     személyre szabó mezők között görget, a kettő egymásra csúszik, és a
     Teeinblue gombsora „beragad" a mi gombunk alá.

     A megoldás: amíg a Teeinblue gombsora oda van tapadva a képernyő aljára
     (tehát a mezők között vagyunk), a mi sávunkat elrejtjük. A mezők ELŐTT és
     UTÁN újra csak a „Személyre szabom" látszik.

     Miért a „le van tapadva" feltétel és nem a puszta láthatóság: az űrlap
     vége után a gombsor még felfelé kigörög a képernyőről — ilyenkor már nem
     tapad, tehát a mi sávunk visszajön, ahogy a tulaj kérte. */
  function egySavLatszik() {
    const doboz = document.querySelector('.tee-btn-wrapper--personalize');
    if (!doboz) return;
    const gombsor = document.getElementById('teeFormActions');

    if (window.innerWidth > 749) {
      if (doboz.hasAttribute('data-brinuti-rejt')) doboz.removeAttribute('data-brinuti-rejt');
      if (gombsor) gombsor.removeAttribute('data-brinuti-alap');
      return;
    }

    /* A mezők KÖZÖTT vagyunk-e? Nem azt nézzük, le van-e tapadva a Teeinblue
       sávja (azt mi magunk kapcsoljuk, az körkörös lenne), hanem magát a
       mezők dobozát: akkor vagyunk „benne”, ha a teteje a képernyő 60%-a
       fölé ért, és az alja még a képernyő alsó negyede alatt van. */
    const mezok = document.getElementById('teeFormInputs');
    let mezokben = false;
    if (mezok && mezok.offsetParent !== null) {
      const mr = mezok.getBoundingClientRect();
      /* A szakasz vége nem a mezők alja, hanem a Teeinblue gombsorának alja:
         az közvetlenül a mezők után áll, és amíg az a képernyőn van, a mi
         sávunk elfedné a gombjait. */
      const gombsorMagassag = gombsor ? gombsor.offsetHeight + 24 : 0;
      mezokben =
        mr.height > 0 &&
        mr.top < window.innerHeight * 0.6 &&
        mr.bottom + gombsorMagassag > window.innerHeight * 0.25;
    }

    if (mezokben) {
      /* A mezők között a Teeinblue gombsora a ragadós sáv, a miénk eltűnik. */
      doboz.setAttribute('data-brinuti-rejt', '');
      if (gombsor) gombsor.removeAttribute('data-brinuti-alap');
    } else {
      /* Előtte és utána csak a „Személyre szabom” látszik — a Teeinblue
         sávja ilyenkor a saját helyén marad, nem tapad a gombunk alá. */
      if (doboz.hasAttribute('data-brinuti-rejt')) doboz.removeAttribute('data-brinuti-rejt');
      if (gombsor && !gombsor.hasAttribute('data-brinuti-alap')) gombsor.setAttribute('data-brinuti-alap', '');
    }
  }

  /* Görgetéskor képkockánként egyszer futunk — a mérés olcsó, de
     görgetésenként több százszor nem kell. */
  let savVar = false;
  function savFrissites() {
    if (savVar) return;
    savVar = true;
    requestAnimationFrame(function () {
      savVar = false;
      egySavLatszik();
    });
  }

  function indul() {
    mobilonLathato();
    safeArea();
    allapotFrissites();
    egySavLatszik();
    window.addEventListener('scroll', savFrissites, { passive: true });
    window.addEventListener('resize', savFrissites);

    const cel = document.querySelector('.product-details') || document.body;
    new MutationObserver(halasztottFrissites).observe(cel, { childList: true, subtree: true });
    ['input', 'change', 'click'].forEach(function (nev) {
      document.addEventListener(nev, halasztottFrissites, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', indul);
  } else {
    indul();
  }
})();
